import React from 'react'

import { ProductApi } from '../../api/product_api'
import { DropzoneArea } from 'material-ui-dropzone'
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import './styles.scss';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Suggestor from '../../utils/suggest'
import Resizer from 'react-image-file-resizer';
import Notification from '../Notifications';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
var QRCode = require('qrcode.react');
import _ from "lodash";
import NewWindow from 'react-new-window'
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';


function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };


export class NewProductView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            files: [],
            open: false,
            productTypes: null,
            productTypeAttributes: [],
            selectedOption: null,
            imgContent: null,
            value: '',
            price: null,
            suggestions: [],
            brands: [],
            showMsg: false,
            msgType: "error",
            msg: null,
            openPrintQr: false,
            printQr: true,
            canCreate: false,
            newProduct: {
                'brand': '', 'model': null, 'description': null,
                'stock': null, 'price': null, 'image': null, 'product_type': null, 'attributes': {}
            }
        };
        this.createProduct = this.createProduct.bind(this);
        this.handleProdTypeChange = this.handleProdTypeChange.bind(this);

    }

    componentDidMount() {
        ProductApi.getProductTypes()
            .then((response) => {
                return response.data
            })
            .then((data) => {
                let prodTypes = []
                let prodTypeAttrs = []
                data.map((item) => {
                    if(item.name != "Reparacion"){
                        prodTypes.push({ 'value': item.id, "label": item.name })
                        prodTypeAttrs[item.id] = []
                        item.attributes.map((attribute) => {
                            prodTypeAttrs[item.id].push({ "type": attribute.type, "name": attribute.name })
                        });
                    }
                    

                })

                let option = null;
                if (prodTypes.length >0){
                    option = prodTypes[0].label
                }
                this.setState({ selectedOption: prodTypes[0], productTypes: prodTypes, productTypeAttributes: prodTypeAttrs })
            })
        ProductApi.getBrands().then(response => {
            this.setState({ brands: response.data })
        })
    }

    handleProdTypeChange(selectedOption) {
        let newProd = {}
        newProd['product_type'] = selectedOption.label
        newProd['brand'] = null
        newProd['price'] = null
        newProd['stock'] = null
        newProd['description'] = ''
        newProd['model'] = null
        newProd['attributes'] = null
        this.setState({ newProduct: newProd, selectedOption });
    };

    handleFileChange(files) {

        if (files.length > 0) {
            Resizer.imageFileResizer(files[0], 500, 500, 'JPEG', 100, 0, uri => {
                let newProd = this.state.newProduct
                newProd['image'] = uri
                this.setState({ newProduct: newProd })
            },
                'base64'
            );
        };
        this.setState({
            files: files
        });
    }
    setAttributeValues = (name, type, value) => {
        let newProd = this.state.newProduct
        if (type == 'integer') {
            value = parseInt(value)
        }
        if(newProd.attributes == null){
            newProd.attributes = {}
        }
        newProd['attributes'][name] = value
        this.setState({ newProduct: newProd })
    }

    donePrinting = () =>{
        this.setState({ openPrintQr: false, prodId: null })
    }
    createProduct(e) {
        e.preventDefault()
        let prod = this.state.newProduct

        if( prod.product_type == null){
            prod.product_type = this.state.productTypes[0].label
        }
        const ix = _.findIndex(this.state.productTypes, function(o) { return o.label == prod.product_type; });
        console.log(this.state.productTypes)
        console.log(this.state.newProduct.product_type)
        console.log(ix)
        let defaultAtrrs = {}
        try{
            const attrs = this.state.productTypeAttributes[this.state.productTypes[ix].value]
            let defaultAtrrs = this.state.newProduct.attributes
            attrs.map((atr)=>{
                if(defaultAtrrs[atr.name] === undefined){
                    if(atr.type == 'Boolean'){
                        defaultAtrrs[atr.name] = false
                    }
                    
                    else if(atr.type == 'String' && atr.name == 'Color'){
                        defaultAtrrs[atr.name] = 'Blanco'
                    }
    
                }
            });
        }catch(e){
            console.log(e)
            
        }
       
        let newProd = this.state.newProduct
        if(newProd.attributes == null){
            delete newProd.attributes
        }
        console.log(newProd)
        ProductApi.createProduct(newProd)
        .then(response =>{
            const code = response.data.data.id
            this.setState({showMsg: true, msg: 'Codigo Producto: ' + code, msgType: "success"})
            if(this.state.printQr){
                this.setState({ openPrintQr: true, prodId: code })
            }
            
            ProductApi.getBrands().then(response=> {
                this.setState({brands: response.data})
            })

        })
        .catch(error=>{
            let msg = 'Intente nuevamente'
            if(error.response.status == 406){
                msg = 'El Producto ya existe'
            }
            else if(error.response.status == 422){
                msg = 'verifique los campos'

            }
            this.setState({showMsg: true, msg: msg, msgType: "error"})

        })


    }
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ showMsg: false });
    }


    setDefaults = (name, type, value) => {
        const newProd = this.state.newProduct
        if (type == 'integer') {
            value = parseInt(value)
        }
        if (type == 'float') {
            value = parseFloat(value)
        }
        if (type == "text"){
            value = value.toUpperCase()
        }
        newProd[name] = value
        this.setState({ newProduct: newProd })
        this.canCreate()

    }
    
    canCreate = () => {
        const model = this.state.newProduct['model'] 
        const price = this.state.newProduct['price'] 
        const stock = this.state.newProduct['stock']
        if(model == null || model == "" || price== null || price < 1 || isNaN(price) || isNaN(stock) || stock == null || stock < 0){
            this.setState({canCreate: false})
            return
        }else{
            this.setState({canCreate: true})
        }
     
    }


    render() {

        let attributes = { 'check': [], 'noCheck': [] };
        if (this.state.selectedOption) {
            this.state.productTypeAttributes[this.state.selectedOption.value].map(attribute => {

                const currentAttributes = this.state.newProduct.attributes
                let newAttribute = null;
                if (attribute['type'].toLowerCase() == "string") {
                    newAttribute = <TextField
                    placeholder={attribute["name"]}
                        onChange={(e) => this.setAttributeValues(attribute["name"], 'string', e.target.value)}
                        style={{ marginRight: 15 }}
                        type="text"
                        onInput={toInputUppercase}
                        value={currentAttributes != null?currentAttributes[attribute.name]:''}
                    />
                    attributes['noCheck'].push(newAttribute)
                }
                else if (attribute["type"].toLowerCase() == "integer") {
                    newAttribute = <TextField
                        placeholder={attribute["name"]}
                        onChange={(e) => this.setAttributeValues(attribute["name"], 'integer', e.target.value)}
                        type="number"
                        style={{ marginRight: 15 }}
                        // value={this.state.newProduct['attributes'][attribute['name']]}
                        value={currentAttributes != null?currentAttributes[attribute.name]:null}
                    />
                    attributes['noCheck'].push(newAttribute)

                }
                else {
                    newAttribute = <FormControlLabel
                        control={
                            <Checkbox
                                checked={currentAttributes != null?currentAttributes[attribute.name]:false}
                                onChange={(e) => this.setAttributeValues(attribute["name"], 'boolean', e.target.checked)}
                            />
                        }
                        label={attribute["name"]}

                    />
                    attributes['check'].push(newAttribute)
                }

            })
        }
        let qrs = []
        if(this.state.openPrintQr){
            
            for(let i=0; i < this.state.newProduct['stock']; i++ ){
                qrs.push(<div style={{marginLeft:25,  marginRight:15, marginTop:1}}>
                    <Typography style={{marginLeft: 5, marginTop:-20}} variant="caption">
                                {this.state.prodId.toString()}
                            </Typography>
                    <div class="grid-child green" >
                    
                            <QRCode
                                size={38}
                                quality={1}
                                errorCorrectionLevel={'high'}
                                renderAs={'svg'}
                                version={40}
                                level={"H"}
                                value={this.state.prodId.toString()}
                                >
                            </QRCode>
                            
                        </div>
                        </div>  )
            }
           
        }
        return (
            
            <div style={{ marginTop: 30 }}>
                <Divider />
                <div className='col-md-10' style={{ marginTop: 10 }}>
                    <div className='col-md-8'>
                        <Typography variant="h6" gutterBottom>
                            Datos del producto
                        </Typography>

                    </div>
                    <div className='col-md-4'>
                        <Select
                            value={this.state.selectedOption}
                            onChange={this.handleProdTypeChange}
                            options={this.state.productTypes}
                        />
                    </div>
                    <div className='col-md-12' style={{ marginTop: 10 }}>
                        <Divider />
                    </div>

                    <div className='col-md-2'>
                        <TextField
                            label="Precio"
                            onChange={(e) => this.setDefaults('price', 'float', e.target.value)}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                            style={{ maxWidth: 80 }}
                            type='text'
                            value={this.state.newProduct['price']}
                        />


                    </div>
                    <div className='col-md-8'>
                        <TextField
                            label="Stock"
                            onChange={(e) => this.setDefaults('stock', 'integer', e.target.value)}
                            style={{ maxWidth: 60 }}
                            value={this.state.newProduct['stock']}
                            type='number'

                        />
                    </div>
                    <div className='col-md-3' style={{ marginTop: 10 }}>
                        <Suggestor
                            setValue={(e) => this.setDefaults('brand', 'text', e)}
                            suggestions={this.state.brands}
                            label="Marca"
                            onInput={toInputUppercase}
                            placeholder="SAMSUNG.."
                        />

                    </div>
                    <div className="col-md-8" style={{ marginTop: 10 }}>

                        <TextField
                            label="Modelo"
                            onChange={(e) => this.setDefaults('model', 'text', e.target.value)}
                            style={{ marginLeft: 15 }}
                            type="text"
                            onInput={toInputUppercase}
                            value={this.state.newProduct['model']}

                        />
                        <TextField
                            label="Descripcion"
                            onChange={(e) => this.setDefaults('description', 'text', e.target.value)}
                            style={{ marginLeft: 15, marginTop: -30 }}
                            multiline={true}
                            rows={2}
                            rowsMax={4}
                            onInput={toInputUppercase}
                            variant="outlined"
                            type='text'
                            value={this.state.newProduct['description']}
                        />

                    </div>
                    <div className="col-md-8" >
                        {this.state.productTypeAttributes &&
                            <div>

                                {attributes['noCheck']}

                            </div>

                        }
                    </div>

                    <div className='col-md-1' style={{ marginTop: 20 }}>
                        {this.state.productTypeAttributes &&
                            <div>
                                {attributes['check']}
                            </div>
                        }

                    </div>

                </div>

                <div className="col-md-2" style={{ marginTop: 10 }}>
                    <DropzoneArea
                        onChange={this.handleFileChange.bind(this)}
                        acceptedFiles={['image/jpeg', 'image/png', 'image/jpg']}
                        maxFileSize={500000}
                        showPreviewsInDropzone={true}
                        filesLimit={1}
                        dropzoneText={""}
                        dropZoneClass="MyDropZone" />
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.printQr}
                                    onChange={(event) => {
                                        this.setState({ printQr: !this.state.printQr });
                                    }
                                    }
                                    color="primary"

                                />
                            }
                            label='Generar QR'
                        />
                    </FormGroup>

                </div>

                <div className="col-md-1 col-md-offset-10">
                    <Button
                        onClick={this.createProduct}
                        variant="contained"
                        color="primary"
                        disabled={!this.state.canCreate}
                        // disabled={[this.state.newProduct['model'] && this.state.newProduct['price'] && this.state.newProduct['stock']].map(e => e == null || e == '')[0]}
                    >

                        Crear
                    </Button>
                </div>
                <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />
                {this.state.openPrintQr &&
                    <NewWindow onUnload={this.donePrinting}>
                        <div class="grid-container">
                        {qrs}
                        </div>
                        </NewWindow>
                    }
               
              
            </div>
        )
    }

}


export default NewProductView;


// WEBPACK FOOTER //
// ./src/components/Products/NewProduct.js